import React from 'react';
import HeroSection from '../HeroSection';
import AboutMe from '../AboutMe';
import Articles from '../Articles';
import Resume from '../Resume';
import Projects from '../Projects';
import Footer from '../Footer';
import SectionTransition from '../SectionTransition';

function Home() {
  return (
    <main>
      <HeroSection />

      <SectionTransition>
        <AboutMe />
      </SectionTransition>

      <SectionTransition>
        <Resume />
      </SectionTransition>

      <SectionTransition>
        <Articles />
      </SectionTransition>

      <SectionTransition>
        <Projects />
      </SectionTransition>

      <Footer />
    </main>
  );
}

export default Home;
